/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CalculationQueueItemDto } from '../models/calculation-queue-item-dto';
import { getQueue } from '../fn/calculation-queue-item-controller/get-queue';
import { GetQueue$Params } from '../fn/calculation-queue-item-controller/get-queue';

@Injectable({ providedIn: 'root' })
export class CalculationQueueItemControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getQueue()` */
  static readonly GetQueuePath = '/v1/queue/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQueue()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQueue$Response(params?: GetQueue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalculationQueueItemDto>>> {
    return getQueue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getQueue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQueue(params?: GetQueue$Params, context?: HttpContext): Observable<Array<CalculationQueueItemDto>> {
    return this.getQueue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CalculationQueueItemDto>>): Array<CalculationQueueItemDto> => r.body)
    );
  }

}
